module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "routerView"
  }, [_c('mheader', {
    ref: "mheader"
  }), _vm._v(" "), _c('div', {
    staticClass: "mat"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-container"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('sidebar'), _vm._v(" "), _c('router-view', {
    staticClass: "content-wrapper clearfix"
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-034c4f2c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/spView.vue
// module id = 1066
// module chunks = 1